import React from 'react';
import Tooltip from '@components/acca/results/result/tooltip';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import SynergyCard from './synergyCard';
import { competenceProfileMap } from '@domain/constant/acca/test/result/competenceType';
import classNames from 'classnames/bind';
import styles from './competencySynergies.module.scss';

const titles = ['궁합 찰떡인 리더', '같이 일하면 좋은 동료', '나와 잘 맞는 팔로워'];
const cx = classNames.bind(styles);

const synergyTooltipContent = (
  <>
    <p>응시자님의 유형을 바탕으로 잘 맞을 수 있는 리더, 동료, 팔로워 유형을 보여줍니다.</p>
    <p>궁합 찰떡인 리더는 응시자님의 약점을 보완하며 응시자님을 이끌어줄 수 있는 유형입니다.</p>
    <p>같이 일하면 좋은 동료는 응시자님과 비슷한 특징을 가진 유형으로 함께 시너지를 낼 수 있는 유형입니다.</p>
    <p>
      나와 잘 맞는 팔로워는 응시자님의 강점을 좋게 생각하며 잘 따를 수 있는 유형으로, 해당 유형의 약점을 응시자님이
      보완해 줄 수 있습니다.
    </p>
  </>
);

interface CompetencySynergiesProps {
  setModalVisible: (modalVisible: boolean) => void;
}

const CompetencySynergies = ({ setModalVisible }: CompetencySynergiesProps) => {
  const { accaResultStore } = useResultStore();
  const { accProfileResult } = accaResultStore;

  if (!accProfileResult) return null;

  const {
    name,
    synergy: { leader, coworker, follower },
  } = competenceProfileMap[accProfileResult.type];

  return (
    <div className={cx('contentWrap')}>
      <em className={cx('title')}>
        {name}과 만나면 <span className={cx('emphasis')}>시너지 100배 유형</span>
        <Tooltip type={'competency'} content={synergyTooltipContent} />
      </em>
      <div className={cx('cardWrap')}>
        {[leader, coworker, follower].map((competenceType, index) => (
          <SynergyCard key={titles[index]} title={titles[index]} type={competenceType} />
        ))}
      </div>
      <div className={cx('buttonWrap')}>
        <button className={cx('button')} onClick={() => setModalVisible(true)}>
          12개 역량유형 모두 보기
        </button>
      </div>
    </div>
  );
};

export default CompetencySynergies;
